const KlUBackgroundWhite = {
    beforeMount: (el: HTMLElement) => {
        const baseClass = 'kl-u-bg-white';
        el.classList.add(baseClass);
    },
};

export default KlUBackgroundWhite;
